// @flow
import { IconVolumeUp, IconVolumeOff } from '../../icons/svg';
import AbstractButton from './AbstractButton';
/**
 * An abstract implementation of a button for toggling speaker mute.
 */
export default class AbstractSpeakerButton extends AbstractButton {
    icon = IconVolumeUp;
    toggledIcon = IconVolumeOff;
    /**
     * Handles clicking / pressing the button, and toggles the speaker mute state
     * accordingly.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
        this._setSpeakerMuted(!this._isSpeakerMuted());
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this._isSpeakerMuted();
    }
    /**
     * Helper function to be implemented by subclasses, which must return a
     * {@code boolean} value indicating if speaker is muted or not.
     *
     * @protected
     * @returns {boolean}
     */
    _isSpeakerMuted() {
        // To be implemented by subclass.
        return true;
    }
    /**
     * Helper function to perform the actual setting of the speaker mute / unmute
     * action.
     *
     * @param {boolean} speakerMuted - Whether speaker should be muted or not.
     * @protected
     * @returns {void}
     */
    _setSpeakerMuted(_speakerMuted) {
        // To be implemented by subclass.
    }
}
